<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar-menu></sidebar-menu>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title" :title1="title1" />
        <!-- /product list -->
        <div class="card">
          <div class="card-body">
            <!-- <div class="profile-set"> -->
            <!-- <div class="profile-head"></div> -->
            <!-- <div class="profile-top">
                <div class="profile-content">
                  <div class="profile-contentimg">
                    <img
                      src="../../assets/img/customer/customer5.jpg"
                      alt="img"
                      id="blah"
                    />
                    <div class="profileupload">
                      <input type="file" id="imgInp" />
                      <a href="javascript:void(0);"
                        ><img src="../../assets/img/icons/edit-set.svg" alt="img"
                      /></a>
                    </div>
                  </div>
                  <div class="profile-contentname">
                    <h2>William Castillo</h2>
                    <h4>Updates Your Photo and Personal Details.</h4>
                  </div>
                </div>
                <div class="ms-auto">
                  <a href="javascript:void(0);" class="btn btn-submit me-2">Save</a>
                  <a href="javascript:void(0);" class="btn btn-cancel">Cancel</a>
                </div>
              </div> -->
            <!-- </div> -->


            <h5 class="fw-bold">Company Data</h5>
            <div class="text-danger mb-3">to change this please contact us in <a @click="cekBantuan()"
                class="fw-bold text-danger">here</a></div>

            <form @submit.prevent="update">
              <div class="row">




                <div class="col-lg-6 col-sm-12">
                  <div class="form-group">
                    <label>Company Name</label>
                    <input type="text" v-model="currentData.nama_perusahaan" disabled />
                  </div>
                </div>
                <div class="col-lg-6 col-sm-12">
                  <div class="form-group">
                    <label>Name </label>
                    <input type="text" v-model="currentData.nama_owner" disabled />
                  </div>
                </div>
                <div class="col-lg-6 col-sm-12">
                  <div class="form-group">
                    <label>Phone Number</label>
                    <input type="text" v-model="currentData.telepon" disabled />
                  </div>
                </div>
                <div class="col-lg-6 col-sm-12">
                  <div class="form-group">
                    <label>Total Employee</label>
                    <input type="text" v-model="currentData.jumlah_karyawan" disabled />
                  </div>
                </div>
                <div class="col-lg-6 col-sm-12">
                  <div class="form-group">
                    <label>Type of Bussines</label>
                    <input type="text" v-model="currentData.jenis_usaha" disabled />
                  </div>
                </div>

                <div class="col-lg-12">
                  <div class="form-group">
                    <label>Address</label>
                    <textarea class="form-control" v-model="currentData.alamat" disabled>
                    </textarea>
                  </div>
                </div>

                <pageheader :title="'Operational'" />
                <div class="col-lg-6 col-sm-12">
                  <div class="form-group">
                    <label>Late Tolerance</label>
                    <div class="position-relative">
                      <input type="text" v-model="currentData.toleransi_keterlambatan" />
                      <div class="position-absolute end-0 top-0 d-flex align-items-center h-100 me-2">Minutes</div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 col-sm-12">
                  <div class="form-group">
                    <label>Present Tolerance</label>
                    <div class="position-relative">
                      <input type="text" v-model="currentData.toleransi_kehadiran" />
                      <div class="position-absolute end-0 top-0 d-flex align-items-center h-100 me-2">Hour</div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 col-sm-12">
                  <div class="form-group">
                    <label>Clock in</label>
                    <input type="time" class="form-control" v-model="currentData.jam_buka" />
                  </div>
                </div>
                <div class="col-lg-6 col-sm-12">
                  <div class="form-group">
                    <label>Clock out</label>
                    <input type="time" class="form-control" v-model="currentData.jam_tutup" />
                  </div>
                </div>

                <pageheader :title="'CUT OFF Payroll'" />
                <div class="col-lg-6 col-sm-12">
                  <div class="form-group">
                    <label>Start Cut Off</label>
                    <vue-select :options="cutoffList"
                        :settings="{ settingOption: value, settingOption: value }" 
                        v-model="currentData.start_cut_off"
                        placeholder="Start Cut Off">
                    </vue-select>
                  </div>
                </div>
                <div class="col-lg-6 col-sm-12">
                  <div class="form-group">
                    <label>End Cut Off</label>
                    <vue-select :options="cutoffList"
                        :settings="{ settingOption: value, settingOption: value }" 
                        v-model="currentData.end_cut_off"
                        placeholder="End Cut Off">
                    </vue-select>
                  </div>
                </div>

                <!-- <div class="col-lg-6 col-sm-12">
                  <div class="form-group col-md-4 col-sm-12">
                    <label>Currency</label>

                    <vue-select :options="currencyList"
                        :settings="{ settingOption: value, settingOption: value }" 
                        v-model="currentData.currency"
                        placeholder="">
                    </vue-select>
                  </div>
                </div> -->

                
                <!-- <div class="col-lg-6 col-sm-12">
                  <div class="form-group">
                    <label>Clock out</label>
                    <input type="time" class="form-control" v-model="currentData.jam_tutup" />
                  </div>
                </div> -->

                
                <div class="col-12">
                  <button type="submit" class="btn btn-submit me-2">Submit</button>
                  <router-link type="button" class="btn btn-cancel" to="index">Cancel</router-link>
                </div>
              </div>
            </form>
          </div>
        </div>
        <!-- /product list -->
      </div>
    </div>
  </div>
</template>

<style>
input[type=checkbox] {
  accent-color: #08b77e;
}
</style>
<script>

import Cookies from "js-cookie";
import axios from "axios";
import { base_url, AlertPopup2, AlertBottom, appendForm, timeout, selectedBranch, goPage  } from "@/assets/js/function";
import { watch } from 'vue'


export default {
  name: "profile",

  data() {
    return {
      title: "Profile",
      title1: "User Profile",
      showPassword: false,
      password: null,
      linkContact: '',

      config: "",
      api: "",
      currentData: [],

      cutoffList: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'],
      currencyList: [
        "USD",
        "EUR",
        "JPY",
        "GBP",
        "AUD",
        "CAD",
        "CHF",
        "CNY",
        "HKD",
        "NZD",
        "SEK",
        "KRW",
        "SGD",
        "NOK",
        "MXN",
        "INR",
        "RUB",
        "ZAR",
        "TRY",
        "BRL",
        "TWD",
        "DKK",
        "PLN",
        "THB",
        "IDR",
        "HUF",
        "CZK",
        "ILS",
        "CLP",
        "PHP",
        "AED",
        "COP",
        "SAR",
        "MYR",
        "RON"
      ],
      
    };
  },

  mounted() {

      watch(selectedBranch, () => {
          this.index()
      }, { immediate: true })
  },
  computed: {
    buttonLabel() {
      return this.showPassword ? "Hide" : "Show";
    },
  },
  methods: {
    toggleShow() {
      this.showPassword = !this.showPassword;
    },

    async index() {
      let formData = new FormData();
      appendForm(formData)

      

      const api = base_url + '/v3/settings/profiles';
      const res = await axios.post(api, formData, { timeout });
      const data = res.data;
      
      if(data.status){
       
          this.currentData = data.data.data_profiles[0];

          // for help desk
          this.linkContact = data.data.link_contact;
          


      }else {
          AlertPopup2("error", "", data.message, true, 1500);
      }

      

    },

    async update() {
      
      let formData = new FormData();
      appendForm(formData)

      Object.entries(this.currentData).forEach(([key, value]) => {
        formData.append(key, value);
      });

      // for (let [key, value] of formData.entries()) {
      //           console.log(key, value);
      //       }
            // return true


      const api = base_url + '/v3/settings/profiles_update';
      const res = await axios.post(api, formData, { timeout });
      const data = res.data;
      
      
      if(data.status){
       
        AlertBottom(data.message);
        
        if (this.currentData.start_cut_off) {
          localStorage.setItem("startCutOff", this.currentData.start_cut_off);
        }
        if (this.currentData.end_cut_off) {
          localStorage.setItem("EndCutOff", this.currentData.end_cut_off);
        }


      }else {
          AlertPopup2("error", "", data.message, true, 1500);
      }




    },

    cekBantuan() {
    
      window.open(this.linkContact, '_blank');
      

     
    }


  },

  created() {
    const token = Cookies.get("token_refresh");
    this.config = {
      headers: { Authorization: `Bearer ` + token },
      timeout: 30000,
    }

    const branch = parseInt(localStorage.getItem("selectedBranch")) || 0;

    //Update local and shared state
    this.filter = branch;
    selectedBranch.value = branch;

    this.index();



  }

};
</script>
